import {useContext} from 'react';
import {PageMetaData, HeadTagSetterContext} from './HeadTagSetterContext';

/**
 * Injects main page SEO tag, like a title, meta and keywords. Works both in SSR and browser modes
 */
export function usePageMetaSetter(pageMeta?: PageMetaData) {
	const context = useContext(HeadTagSetterContext);
	if (!context) {
		throw new Error('usePageMetaSetter error: context is not provided');
	}

	if (pageMeta) {
		context.setPageMeta(pageMeta);
	}
}

usePageMetaSetter.displayName = 'usePageMetaSetter';
